import { Status } from '../../shared/base/course-lecture-status';
import { ModelBase } from '../../shared/base/model-base';
import { ObjectObservable } from '../../shared/base/object-observable';
import { User } from '../../users/shared/user';

export class Lecture extends ModelBase {
  $exists: any;
  name: string;
  status?: Status;
  billing = true;
  public = true;
  description?: string;
  syllabus?: string;
  type: string;
  owner?: string;
  ownerObservable?: ObjectObservable<User>;

  changePublic(value: boolean) {
    this.public = value;
  }

  changeBilling(value: boolean) {
    this.billing = value;
  }

  isBilling(): boolean {
    return this.billing === undefined || this.billing;
  }

  isInProgress(): boolean {
    return this.status === undefined || this.status === Status.INPROGRESS;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/shared/lecture.ts